import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";

import axios from "axios";
import { Box, Typography, Slider, Paper, Button, Chip } from "@mui/material";

const LearningGoalWeights = forwardRef(({ exerciseId }, ref) => {
  const [learningGoals, setLearningGoals] = useState([]);
  const [weights, setWeights] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("jwtToken");
      const headers = { Authorization: `Bearer ${token}` };

      const goalsRes = await axios.get(`${process.env.REACT_APP_API_URL}/exercises/learning-goals`, { headers });
      setLearningGoals(goalsRes.data);

      const weightsRes = await axios.get(`${process.env.REACT_APP_API_URL}/exercises/${exerciseId}/learning-goals`, { headers });
      const map = {};
      weightsRes.data.forEach(({ learning_goal_id, weight }) => {
        map[learning_goal_id] = weight;
      });
      setWeights(map);
    };

    if (exerciseId) fetchData();
  }, [exerciseId]);

  const normalizeWeights = (newWeights) => {
  const total = Object.values(newWeights).reduce((sum, w) => sum + (w || 0), 0);
  if (total === 0) return newWeights;

  const normalized = {};
  let runningSum = 0;
  let lastKey = null;

  Object.entries(newWeights).forEach(([key, value]) => {
    if (value > 0) lastKey = key;
  });

  Object.entries(newWeights).forEach(([key, value]) => {
    if (value > 0) {
      const scaled = Math.round((value / total) * 99);
      normalized[key] = scaled;
      runningSum += scaled;
    } else {
      normalized[key] = 0;
    }
  });

  const diff = 99 - runningSum;
  if (diff !== 0 && lastKey) {
    normalized[lastKey] = (normalized[lastKey] || 0) + diff;
  }

  return normalized;
};

  const handleSliderChange = (goalId, newValue) => {
    const updatedWeights = {
      ...weights,
      [goalId]: newValue
    };
    const normalized = normalizeWeights(updatedWeights);
    setWeights(normalized);
  };

  const save = async () => {
    if (!exerciseId) return;
    const token = localStorage.getItem("jwtToken");
    const headers = { Authorization: `Bearer ${token}` };

    const payload = learningGoals.map(g => ({
      learning_goal_id: g.id,
      weight: weights[g.id] || 0
    }));

    await axios.post(`${process.env.REACT_APP_API_URL}/exercises/${exerciseId}/learning-goals`, payload, { headers });
  };

  useImperativeHandle(ref, () => ({
    save
  }));

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Associazioni Learning Goals</Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: 2,
          mt: 2
        }}
      >
        {learningGoals.map(goal => (
        <Paper key={goal.id} elevation={2} sx={{ p: 2 }}>
  <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
    <Typography variant="subtitle2">{goal.name}</Typography>
   <Chip
  label={`${weights[goal.id] || 0}`}
  size="small"
  sx={{
    fontWeight: (weights[goal.id] || 0) > 0 ? 'bold' : 'normal',
    backgroundColor: (weights[goal.id] || 0) > 0 ? '#4caf50' : '#e0e0e0',
    color: (weights[goal.id] || 0) > 0 ? 'white' : 'black'
  }}
/>

  </Box>
  <Slider
    value={weights[goal.id] || 0}
    onChange={(e, val) => handleSliderChange(goal.id, val)}
    min={0}
    max={99}
    step={1}
    marks
    valueLabelDisplay="off"
  />
</Paper>


        ))}
      </Box>
    </Box>
  );
});

export default LearningGoalWeights;
